export const DASHBOARD_PANEL_DELETE_OPEN_MODAL = "DASHBOARD_PANEL_DELETE_OPEN_MODAL";
export const DASHBOARD_PANEL_DELETE_REQUEST = "DASHBOARD_PANEL_DELETE_REQUEST";
export const DASHBOARD_PANEL_DELETE_RESULT = "DASHBOARD_PANEL_DELETE_RESULT";